//---------------------------------------------------------------------
// React, MUI, and other third-party modules imports
//---------------------------------------------------------------------
import React, { useState, useEffect, useContext } from 'react';
// import { useState, useEffect, useContext, useCallback } from 'react';
import { makeStyles, Container, Grid, Checkbox, CircularProgress } from '@material-ui/core';
import { createStyles, withStyles } from '@material-ui/core/styles';
import ArrowRightAltIcon from '@material-ui/icons/ArrowForward';
import ArrowBack from '@material-ui/icons/ArrowBack';
import LinearProgress from '@material-ui/core/LinearProgress';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import ReCAPTCHA from 'react-google-recaptcha';
import { useHistory } from 'react-router-dom';
import { CardNumberElement, CardExpiryElement, CardCvcElement, useStripe, useElements } from '@stripe/react-stripe-js';

//logo and images
import paypalSrc from '../../images/advertise/paypal.png';

//---------------------------------------------------------------------
// Common helpers and constants imports
//---------------------------------------------------------------------
import { RECAPTCHA_SITE_KEY, HOMEPAGE_FAQ, BASE_URL } from '../../common/constants';
import { PATH_ADVERTISE, PATH_HOME, PATH_SUB_PAGE_TERMS } from '../../system/constants';

// import { unsubscribeRealtimeUpdates } from '../system/firebase';
import { LayoutContext } from '../../common/contexts';
import { setClassNameInDefns } from '../../common/definitionHelper';
import { createAdPaymentIntent } from '../../common/services/paymentServices';
import { getConfirmCardPaymentBillingDetails } from '../../common/paymentHelper';

//---------------------------------------------------------------------
// Page specific helpers and constants imports
//---------------------------------------------------------------------
import { purchaseAds } from '../../common/services/adServices';

//---------------------------------------------------------------------
// Common components imports
//---------------------------------------------------------------------
import AfitdTypography from '../../common/elemental/AfitdTypography';
// import AfitdTextField from '../../common/elemental/AfitdTextField';
import AfitdTextField from '../../common/elemental/AfitdTextField';
import AfitdButton from '../../common/elemental/AfitdButton';

//---------------------------------------------------------------------
// Page specific components imports
//---------------------------------------------------------------------
// import SubComponent1Example from './SubComponent1Example';

//---------------------------------------------------------------------
// Utilities (clsx, lodash, date-fns, etc.) imports
//---------------------------------------------------------------------
// import cx from 'clsx';
import _get from 'lodash/get';
import _set from 'lodash/set';
import _some from 'lodash/some';
import _includes from 'lodash/includes';

//---------------------------------------------------------------------
// CSS
//---------------------------------------------------------------------
const useStyles = (params = {}) => {
    // const { } = params;

    const errorMessageStyles = { color: 'red' };

    return makeStyles(theme => ({
        root: { padding: 20 },
        exampleWithNoPropsOnlyStyles: { color: 'red', marginTop: 30, marginBottom: 40 },
        nonReactElementExample: { color: 'blue', marginTop: 50, cursor: 'pointer' },
        container: {
            width: '100%',
            // height: '640px',
            backgroundColor: 'white',
            borderRadius: '10px',
            padding: '48px 112px 48px 112px',
            [theme.breakpoints.down('sm')]: { padding: '44px 0px' },
        },
        heading: {
            fontSize: '26px',
            fontWeight: 'bold',
            textAlign: 'center',
        },
        subHeading: {
            fontSize: '14px',
            textAlign: 'center',
            marginTop: '8px',
            color: '#111E14',
        },
        fieldLabel: {
            fontWeight: 'bold',
            fontSize: '14px',
            lineHeight: '16px',
            marginTop: '20px',
        },
        progressGrid: {
            textAlign: 'center',
        },
        gridBody: {
            marginTop: '20px',
            padding: '24px',
            borderRadius: '8px',
            border: '1px solid #D5D7DD',
        },
        nextButtonDiv: {
            textAlign: 'right',
            marginTop: '20px',
        },
        backButton: {
            textAlign: 'left',
            marginTop: '20px',
        },
        title: {
            fontWeight: 'bold',
            fontSize: '16px',
            marginTop: '12px',
        },
        progressGridContainerSm: {
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            paddingTop: 34,
        },
        reCaptchaError: { color: '#f44336 !important', marginTop: '5px', fontSize: '0.75rem', marginLeft: '15px' },
        termsDiv: {
            display: 'flex',
            alignItems: 'center',
        },
        link: {
            textDecoration: 'underline',
            color: 'darkblue',
            cursor: 'pointer',
        },
        cardInfoContainer: { borderRadius: 4, border: '2px solid rgb(213,215,221)', padding: 20, margin: '5px 0' },
        cardholdersNameInputBox: { flex: 1, padding: '0 5px', marginTop: 0 },
        cardholdersNameLabel: { margin: '0 0 5px 0', fontWeight: 'bold' },

        stripeCardNumberErrorMessage: errorMessageStyles,
        stripeCardExpiryErrorMessage: errorMessageStyles,
        stripeCardCvcErrorMessage: errorMessageStyles,

        inputBoxContainer: { display: 'flex' },
        inputBox: { flex: 1, padding: '0 5px', marginTop: 10 },
        label: { margin: '10px 0 5px 0', fontWeight: 'bold' },
        stripeCardElementDiv: {
            border: '2px solid lightgrey',
            padding: '15px',
            borderRadius: '5px',
        },
    }));
};

//---------------------------------------------------------------------
// Get definitions
//--------------------------------------------------------------a-------
var isDevMode = false;
window.location.hostname === 'localhost' ? (isDevMode = true) : (isDevMode = false);

const getDefns = params => {
    const {
        classes,
        isDirty,
        // setIsDirty,
        formData,
        handleChangeData,
        handleNextButton,
        errors,
        history,
        recaptcha,
        handleChangeStripeCardNumber,
        handleChangeStripeCardExpiry,
        handleChangeStripeCardCvc,
        stripeComplete,
        stripeErrorMessages,
        processingPayment,
    } = params;

    const { cardHoldersNameError } = errors;
    const isStripeCardPaymentReady = getIsStripeCardPaymentReady({ data: formData, stripeComplete, stripeErrorMessages });
    // const isDirty =
    //     formData.cardHoldersName === '' && state === '' && country === '' && city === '' && formData.cvc === '' && formData.expireDate === '' && formData.stripeCardNumber === '';
    const nextBtnDisabled = (isDevMode ? !isDirty : recaptcha && !isDirty) || !isStripeCardPaymentReady || processingPayment;

    const defns = {
        nonReactElementExample: {
            onClick: evt => {
                alert('Clicked!');
            },
        },
        gridBody: {
            container: true,
            spacing: 2,
        },
        gridBody1: {
            container: true,
            spacing: 2,
        },
        itemGrid: { item: true, xs: 12 },
        itemGrid2: { item: true, xs: 6 },
        itemGrid3: { item: true, xl: 2, lg: 2, md: 2, sm: 5, xs: 5 },

        progressGrid: { item: true, xs: 2 },

        cardholdersNameLabel: { variant: 'body2' },
        label: { variant: 'body2' },
        cardHoldersName: {
            name: 'cardHoldersName',
            onChange: handleChangeData,
            value: formData.cardHoldersName,
            error: cardHoldersNameError,
            helperText: cardHoldersNameError ? 'Cardholder Name is required' : undefined,
        },
        // stripeCardNumber: {
        //     name: 'stripeCardNumber',
        //     onChange: handleChangeData,
        //     value: formData.stripeCardNumber,
        //     error: stripeCardNumberError,
        //     helperText: stripeCardNumberError ? 'Card Number is required' : undefined,
        // },
        // expireDate: {
        //     name: 'expireDate',
        //     onChange: handleChangeData,
        //     value: formData.expireDate,
        //     type: 'date',
        //     error: expireDateError,
        //     helperText: expireDateError ? 'Expire Date is required' : undefined,
        // },
        // cvc: {
        //     name: 'cvc',
        //     type: 'text',
        //     onChange: handleChangeData,
        //     value: formData.cvc,
        //     error: cvcError,
        //     helperText: cvcError ? 'CVC is required' : undefined,
        // },
        stripeCardNumber: { onChange: handleChangeStripeCardNumber },
        stripeCardExpiry: { onChange: handleChangeStripeCardExpiry },
        stripeCardCvc: { onChange: handleChangeStripeCardCvc },

        stripeCardNumberErrorMessage: { variant: 'subtitle', value: stripeErrorMessages?.stripeCardNumber },
        stripeCardExpiryErrorMessage: { variant: 'subtitle', value: stripeErrorMessages?.cardExpiry },
        stripeCardCvcErrorMessage: { variant: 'subtitle', value: stripeErrorMessages?.cardCvc },

        footerGridItem: {
            xl: 5,
            lg: 5,
            md: 5,
            sm: 6,
            xs: 6,
        },
        progress: {
            variant: 'determinate',
            value: 100,
        },
        cardHoldersNameErrorText: { hidden: !cardHoldersNameError },
        nextButton: { disabled: nextBtnDisabled, onClick: () => handleNextButton(), color: 'primary' },
        paypal: {
            src: paypalSrc,
            style: {
                width: '100%',
                marginTop: '50px',
                cursor: 'pointer',
            },
        },
        backButton: {
            onClick: () => history.push(`${BASE_URL}${PATH_ADVERTISE}/step4`),
        },
        link: {
            //TODO open page in new window so user don't lose the progress -el 20200910
            onClick: () => history.push(`${PATH_HOME}/${HOMEPAGE_FAQ}/${PATH_SUB_PAGE_TERMS}`),
        },
    };

    // Automatically inject className for matching keys
    setClassNameInDefns(defns, classes);

    return defns;
};

//---------------------------------------------------------------------
// Helper functions
//---------------------------------------------------------------------
const initData = { cardHoldersName: '' };
const initStripeData = { stripeCardNumber: null, cardExpiry: null, cardCvc: null };
const initStripeErrorMessages = { stripeCardNumber: null, cardExpiry: null, cardCvc: null };

const getIsStripeCardPaymentReady = ({ data, stripeComplete, stripeErrorMessages }) => {
    const fieldNames = ['cardHoldersName'];
    const stripeFieldNames = ['stripeCardNumber', 'cardExpiry', 'cardCvc'];
    const hasError = _some(stripeFieldNames, fieldName => stripeErrorMessages[fieldName]);
    const hasIncompleteStripeField = _some(stripeFieldNames, fieldName => !stripeComplete[fieldName]);
    const hasBlankField = _some(fieldNames, fieldName => !data[fieldName]);

    return !hasError && !hasIncompleteStripeField && !hasBlankField;
};

const BorderLinearProgress = withStyles(theme =>
    createStyles({
        root: {
            height: 10,
            borderRadius: 5,
        },
        colorPrimary: {
            backgroundColor: '#F0F2F6',
        },
        bar: {
            borderRadius: 5,
            backgroundColor: '#1D8A8B',
        },
    }),
)(LinearProgress);

//---------------------------------------------------------------------
// Component
//---------------------------------------------------------------------
const Step5Page = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const classes = useStyles(/* {param1} */)();
    const history = useHistory();
    const theme = useTheme();
    const smMatches = useMediaQuery(theme.breakpoints.down('sm'));
    // const appContext = useContext(AppContext);
    // const { currentUser, userId, profileData, currentEmployer, employerId, lovs } = appContext;

    const layoutContext = useContext(LayoutContext);
    const { scrollToPageTop, customerData, setShowTimer, setSnackbarMessage, setSnackbarErrorMessage, onHoldDocIds, paymentIntentDescription } = layoutContext;

    const adCusId = _get(customerData, 'adCusId', null);
    const companyName = _get(customerData, 'companyName', null);
    const poc = _get(customerData, 'poc', null);
    const phone = _get(customerData, 'phone', null);
    const email = _get(customerData, 'email');

    // const { setSnackbarMessage, setSnackbarErrorMessage } = layoutContext;

    // Initialize an instance of stripe.
    const stripe = useStripe();
    const stripeElements = useElements();

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------
    // const { propExample } = props;

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------
    const [isDirty, setIsDirty] = useState(false);
    const [recaptcha, setReCaptcha] = React.useState(null);
    const [acceptedTerms, setAcceptedTerms] = React.useState(false);
    const [processingPayment, setProcessingPayment] = React.useState(false);
    const [stripeComplete, setStripeComplete] = useState(initStripeData);
    const [stripeErrorMessages, setStripeErrorMessages] = useState(initStripeErrorMessages);
    // const [isProcessingPayment, setIsProcessingPayment] = useState(false);

    const [errors, setErrors] = React.useState({
        cardHoldersNameError: false,
        cvcError: false,
        stripeCardNumberError: false,
        expireDateError: false,
        recaptchaError: false,
        acceptedTermsErrors: false,
    });
    const [formData, setFormData] = React.useState(initData);

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------
    // on mount, scroll to the top of the page
    useEffect(() => {
        scrollToPageTop();
    }, [scrollToPageTop]);

    useEffect(() => {
        if (!adCusId) history.push(`${BASE_URL}${PATH_ADVERTISE}/start`);
        // don't need to run multiple Times
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // useCallback / Event handlers
    //---------------------------------------------------------------------
    const handleChangeData = React.useCallback(
        evt => {
            const { name, value } = evt.target;
            setFormData({ ...formData, [name]: value });
            setIsDirty(true);
        },
        [formData],
    );

    const validate = () => {
        let newErrors = { ...errors };
        // // !formData.cardHoldersName && _set(newErrors, 'cardHoldersNameError', true);
        // // formData.cardHoldersName && _set(newErrors, 'cardHoldersNameError', false);
        // // !formData.stripeCardNumber && _set(newErrors, 'stripeCardNumberError', true);
        // // formData.stripeCardNumber && _set(newErrors, 'stripeCardNumberError', false);
        // // !formData.expireDate && _set(newErrors, 'expireDateError', true);
        // // formData.expireDate && _set(newErrors, 'expireDateError', false);
        // // !formData.cvc && _set(newErrors, 'cvcError', true);
        // // formData.cvc && _set(newErrors, 'cvcError', false);
        !acceptedTerms && _set(newErrors, 'acceptedTermsErrors', true);
        acceptedTerms && _set(newErrors, 'acceptedTermsErrors', false);
        if (!isDevMode) {
            !recaptcha && _set(newErrors, 'recaptchaError', true);
            recaptcha && _set(newErrors, 'recaptchaError', false);
        }

        setErrors(newErrors);
        return !_includes(newErrors, true);
    };

    const handleNextButton = async () => {
        if (validate()) {
            setProcessingPayment(true);

            const paymentIntentMetadata = {
                adCusId,
                companyName,
                poc,
                phone,
                email,
            };
            const paymentIntentResp = await createAdPaymentIntent({
                adIdList: onHoldDocIds,
                receiptEmail: email,
                description: paymentIntentDescription,
                metadata: paymentIntentMetadata,
            });

            const intentError = paymentIntentResp?.error;

            if (!intentError) {
                //-------------------------------------------------------------------------------------------
                // NOTE: This Stripe API must be called from here for the 'card' param to work.
                //       Pass in CardNumberElement and Stripe.js SDK will automatically pull in
                //       CardExpiryElement and CardCvcElement.
                //-------------------------------------------------------------------------------------------
                const clientSecret = paymentIntentResp.data?.client_secret;
                const cardHoldersName = formData?.cardHoldersName;

                const confirmResp = await stripe.confirmCardPayment(clientSecret, {
                    payment_method: {
                        card: stripeElements.getElement(CardNumberElement),
                        billing_details: getConfirmCardPaymentBillingDetails({ cardHoldersName }),
                        // billing_details: { address: { country: 'Hong Kong' } }, //! Use this to throw error
                    },
                });

                const confirmError = confirmResp?.error;

                if (confirmError) {
                    // handle card payment error
                    console.error(confirmError.message);
                    setSnackbarErrorMessage('Payment Failed');
                    setProcessingPayment(false);
                } else {
                    await purchaseAds({
                        onHoldDocIds,
                        setSnackbarMessage,
                        setSnackbarErrorMessage,
                        setProcessingPayment,
                        callBack: () => {
                            history.push(`${BASE_URL}${PATH_ADVERTISE}/success`);
                            setProcessingPayment(false);
                            setShowTimer(false);
                            localStorage.removeItem('onHoldEndDt');
                        },
                    });
                }
            } else {
                // handle payment intent error
                console.error(intentError.message);
                setSnackbarErrorMessage('Invoice Failed');
                setProcessingPayment(false);
            }
        }
    };

    const onReCaptchaChange = value => {
        setReCaptcha(value);
    };

    const handleChangeTerms = e => {
        setAcceptedTerms(e.target.checked);
        setIsDirty(true);
    };
    // console.log({ onHoldDocIds });

    const handleChangeStripeCardNumber = field => {
        const complete = !!field?.complete;
        setStripeComplete(prev => ({ ...prev, stripeCardNumber: complete }));

        console.log(field);

        const msg = field?.error ? field.error.message : null;
        setStripeErrorMessages(prev => ({ ...prev, stripeCardNumber: msg }));
    };

    const handleChangeStripeCardExpiry = field => {
        const complete = !!field?.complete;
        setStripeComplete(prev => ({ ...prev, cardExpiry: complete }));

        const msg = field?.error ? field.error.message : null;
        setStripeErrorMessages(prev => ({ ...prev, cardExpiry: msg }));
    };

    const handleChangeStripeCardCvc = field => {
        const complete = !!field?.complete;
        setStripeComplete(prev => ({ ...prev, cardCvc: complete }));

        const msg = field?.error ? field.error.message : null;
        setStripeErrorMessages(prev => ({ ...prev, cardCvc: msg }));
    };

    //---------------------------------------------------------------------
    // Definitions
    //---------------------------------------------------------------------
    const defns = getDefns({
        classes,
        props,
        isDirty,
        setIsDirty,
        formData,
        setFormData,
        handleChangeData,
        handleNextButton,
        errors,
        history,
        recaptcha,
        validate,
        handleChangeStripeCardNumber,
        handleChangeStripeCardExpiry,
        handleChangeStripeCardCvc,
        stripeComplete,
        stripeErrorMessages,
        processingPayment,
    });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <div {...defns.root}>
            <Container {...defns.container}>
                <div {...defns.heading}>Payment Information</div>
                {/* <div {...defns.subHeading}>You will only be charged if approved</div> */}
                {/* <img {...defns.paypal} alt="" /> */}
                <div {...defns.title}>Enter Credit Card info</div>
                {/* <Grid {...defns.gridBody}>
                    <Grid {...defns.itemGrid}>
                        <p {...defns.fieldLabel}>Cardholder Name: </p>
                        <AfitdTextField {...defns.cardHoldersName} />
                    </Grid>

                    <Grid {...defns.itemGrid}></Grid>
                    <Grid {...defns.itemGrid}>
                        <p {...defns.fieldLabel}>Card Number:</p>
                        <AfitdTextField {...defns.stripeCardNumber} />
                    </Grid>
                    <Grid {...defns.itemGrid2}>
                        <p {...defns.fieldLabel}>Expiration Date:</p>
                        <AfitdTextField {...defns.expireDate} />
                    </Grid>
                    <Grid {...defns.itemGrid3}>
                        <p {...defns.fieldLabel}>CVC code:</p>
                        <AfitdTextField {...defns.cvc} />
                    </Grid>
                </Grid> */}

                <div {...defns.cardInfoContainer}>
                    <div {...defns.cardholdersNameInputBox}>
                        <AfitdTypography {...defns.cardholdersNameLabel}>Cardholder name</AfitdTypography>
                        <AfitdTextField {...defns.cardHoldersName} />
                    </div>
                    <div {...defns.inputBox}>
                        <AfitdTypography {...defns.label}>Card number</AfitdTypography>
                        {/* <AfitdNumberFormat {...defns.cardNumber} customInput={AfitdTextField} /> */}
                        <div {...defns.stripeCardElementDiv}>
                            <CardNumberElement
                                options={{
                                    showIcon: true,
                                    style: {
                                        base: {
                                            fontSize: '16px',
                                        },
                                    },
                                }}
                                {...defns.stripeCardNumber}
                            />
                        </div>
                        {stripeErrorMessages?.stripeCardNumber && <AfitdTypography {...defns.stripeCardNumberErrorMessage} />}
                    </div>
                    <div {...defns.inputBoxContainer}>
                        <div {...defns.inputBox}>
                            <AfitdTypography {...defns.label}>Expiration Date</AfitdTypography>
                            {/* <AfitdNumberFormat {...defns.cardExpiryDate} customInput={AfitdTextField} format={checkCardExpiryDate} /> */}
                            <div {...defns.stripeCardElementDiv}>
                                <CardExpiryElement
                                    options={{
                                        style: {
                                            base: {
                                                fontSize: '16px',
                                            },
                                        },
                                    }}
                                    {...defns.stripeCardExpiry}
                                />
                            </div>
                            {stripeErrorMessages?.cardExpiry && <AfitdTypography {...defns.stripeCardExpiryErrorMessage} />}
                        </div>
                        <div {...defns.inputBox}>
                            <AfitdTypography {...defns.label}>CVC Code</AfitdTypography>
                            {/* <AfitdNumberFormat {...defns.cardCVC} customInput={AfitdTextField} /> */}
                            <div {...defns.stripeCardElementDiv}>
                                <CardCvcElement
                                    options={{
                                        style: {
                                            base: {
                                                fontSize: '16px',
                                            },
                                        },
                                    }}
                                    {...defns.stripeCardCvc}
                                />
                            </div>
                            {stripeErrorMessages?.cardCvc && <AfitdTypography {...defns.stripeCardCvcErrorMessage} />}
                        </div>
                    </div>
                </div>
                <br />
                <div {...defns.termsDiv}>
                    <Checkbox checked={acceptedTerms} onChange={handleChangeTerms} /> &nbsp;&nbsp;
                    <AfitdTypography>
                        I and/or the organization that I am purchasing this ad on behalf of completely accept the <span {...defns.link}>Terms of Use</span>
                    </AfitdTypography>
                </div>
                {errors?.acceptedTermsErrors && <AfitdTypography {...defns.reCaptchaError}>Please accept the terms and conditions to process further</AfitdTypography>}
                {!isDevMode && (
                    <>
                        <br />
                        <ReCAPTCHA sitekey={RECAPTCHA_SITE_KEY} onChange={onReCaptchaChange} />
                        {(recaptcha === null || errors?.recaptchaError) && <AfitdTypography {...defns.reCaptchaError}>Please Verify yourself</AfitdTypography>}
                    </>
                )}
                <br />
                <Grid {...defns.gridBody1}>
                    <Grid {...defns.footerGridItem}>
                        <div {...defns.backButton}>
                            <AfitdButton {...defns.backButton}>
                                <ArrowBack fontSize="small" />
                                &nbsp; Back {` `}
                            </AfitdButton>
                        </div>
                    </Grid>
                    {smMatches ? null : (
                        <Grid {...defns.progressGrid}>
                            <p>
                                <b>5 of 5</b>
                            </p>
                            <BorderLinearProgress {...defns.progress} />
                        </Grid>
                    )}

                    <Grid {...defns.footerGridItem}>
                        <div {...defns.nextButtonDiv}>
                            <AfitdButton {...defns.nextButton}>
                                {processingPayment ? (
                                    <>
                                        <CircularProgress size={25} /> &nbsp; Processing...
                                    </>
                                ) : (
                                    <>
                                        Purchase {` `}
                                        &nbsp;
                                        <ArrowRightAltIcon fontSize="small" />
                                    </>
                                )}
                            </AfitdButton>
                        </div>
                    </Grid>
                    {smMatches && (
                        <div {...defns.progressGridContainerSm}>
                            <Grid {...defns.progressGrid}>
                                <p>
                                    <b>5 of 5</b>
                                </p>
                                <BorderLinearProgress {...defns.progress} />
                            </Grid>
                        </div>
                    )}
                </Grid>
            </Container>
        </div>
    );
};

export default Step5Page;
